import { ProductSalesReportField } from "src/app/enums/Report/ReportField/ProductSales/ProductSalesReportField";
import { ReportSortDefinition } from "../Components/IReportSortDefinition";
import { ProductSalesReportVariant } from "src/app/enums/Report/ReportField/ProductSales/ProductSalesReportVariant";
import { DateRangeParameter } from "./DateRangeParameter";
import { BaseReportParameters } from "./BaseReportParameters";

const localStorageFormParametersProperty = 'ProductSalesReportParameters';

export class ProductSalesReportParameters extends BaseReportParameters {
  reportGroup: ProductSalesReportField;
  reportSubGroup: ProductSalesReportField;
  variant: ProductSalesReportVariant;
  posId: number;
  clerkId: number;
  categoryId: string;
  parentCategoryId: string;
  courseId: string;
  productId: string;
  salesDateRange: DateRangeParameter;
  sort: ReportSortDefinition[];

  constructor() {
    super(localStorageFormParametersProperty);
  }

  protected getParameters(storedParameters: ProductSalesReportParameters) {
    this.variant = <ProductSalesReportVariant>(storedParameters?.variant ?? ProductSalesReportVariant.Consolidated);
    this.reportGroup = <ProductSalesReportField>(storedParameters?.reportGroup ?? ProductSalesReportField.None);
    this.reportSubGroup = <ProductSalesReportField>(storedParameters?.reportSubGroup ?? ProductSalesReportField.None);
    this.posId = storedParameters?.posId ?? -1;
    this.clerkId = storedParameters?.clerkId ?? -1;
    this.categoryId = storedParameters?.categoryId ?? '';
    this.parentCategoryId = storedParameters?.parentCategoryId ?? '';
    this.courseId = storedParameters?.courseId ?? '';
    this.productId = storedParameters?.productId ?? '';
    this.salesDateRange = new DateRangeParameter(storedParameters?.salesDateRange);
  }
}
